import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "\n        rounded-b-lg \n        border-l border-r\n        flex flex-col\n        bg-white\n        rounded-bl rounded-br\n        shadow\n        overflow-y-auto\n      ",
  style: {"max-height":"85vh","width":"400px"}
}
const _hoisted_2 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_3 = { class: "inline" }
const _hoisted_4 = { class: "font-semibold text-16px pr-2 pl-4 float-left" }
const _hoisted_5 = {
  key: 0,
  class: "text-black-lp-200 pr-3 float-right"
}
const _hoisted_6 = { class: "rounded px-2 py-0 bg-gray-lp-400 text-12px xxl:text-14px" }
const _hoisted_7 = { class: "capitalize" }
const _hoisted_8 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_9 = { class: "inline" }
const _hoisted_10 = { class: "text-gray-lp-600 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_11 = { class: "pt-2" }
const _hoisted_12 = { class: "pt-2" }
const _hoisted_13 = { class: "pt-2" }
const _hoisted_14 = { class: "pt-2 text-black-lp-300" }
const _hoisted_15 = { class: "text-gray-lp-600 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_16 = { class: "pt-2 text-right" }
const _hoisted_17 = { class: "pt-2 text-right" }
const _hoisted_18 = { class: "pt-2 text-right" }
const _hoisted_19 = { class: "pt-2 text-right text-black-lp-300" }
const _hoisted_20 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_21 = { class: "inline" }
const _hoisted_22 = { class: "text-gray-lp-600 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_23 = { class: "pt-2" }
const _hoisted_24 = { class: "pt-2" }
const _hoisted_25 = { class: "pt-2" }
const _hoisted_26 = { class: "pt-2" }
const _hoisted_27 = { class: "pt-2 text-black-lp-300" }
const _hoisted_28 = { class: "text-gray-lp-600 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_29 = { class: "pt-2 text-right" }
const _hoisted_30 = { class: "pt-2 text-right" }
const _hoisted_31 = { class: "pt-2 text-right" }
const _hoisted_32 = { class: "pt-2 text-right" }
const _hoisted_33 = { class: "pt-2 text-right text-black-lp-300" }
const _hoisted_34 = { class: "border-b border-gray-lp-400 py-4 flex-col flex" }
const _hoisted_35 = { class: "inline" }
const _hoisted_36 = { class: "text-black-lp-300 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_37 = { class: "pt-2 flex" }
const _hoisted_38 = {
  key: 0,
  class: "text-black-lp-200 ml-1"
}
const _hoisted_39 = { class: "rounded px-2 py-0 bg-gray-lp-400 text-12px xxl:text-14px" }
const _hoisted_40 = { class: "capitalize" }
const _hoisted_41 = { class: "text-black-lp-300 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_42 = { class: "pt-2 text-right" }
const _hoisted_43 = {
  key: 0,
  class: "inline"
}
const _hoisted_44 = { class: "text-black-lp-300 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_45 = { class: "pt-2 flex" }
const _hoisted_46 = { class: "text-black-lp-300 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_47 = { class: "pt-2 text-right" }
const _hoisted_48 = {
  key: 0,
  class: "border-b border-gray-lp-400 py-4"
}
const _hoisted_49 = { class: "inline" }
const _hoisted_50 = { class: "text-black-lp-300 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_51 = { class: "pt-2" }
const _hoisted_52 = { class: "pt-2" }
const _hoisted_53 = {
  key: 0,
  class: "pt-2 text-gray-lp-600"
}
const _hoisted_54 = { class: "text-black-lp-300 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_55 = {
  class: "pt-2 text-right",
  "data-testid": "bulk-booking-repair-estimation-cod-goods-value"
}
const _hoisted_56 = {
  class: "pt-2 text-right",
  "data-testid": "bulk-booking-repair-estimation-cod-fee"
}
const _hoisted_57 = {
  key: 0,
  class: "pt-2 text-right text-gray-lp-600"
}
const _hoisted_58 = {
  key: 1,
  class: "border-b border-gray-lp-400 py-4"
}
const _hoisted_59 = { class: "flex flex-row justify-between" }
const _hoisted_60 = { class: "flex text-gray-lp-300 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_61 = { class: " w-36" }
const _hoisted_62 = { class: "items-center ml-5 mt-0.5" }
const _hoisted_63 = { class: "text-12px" }
const _hoisted_64 = { class: "text-gray-lp-300 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_65 = { class: "border-b border-gray-lp-400 py-4 rounded" }
const _hoisted_66 = { class: "inline items-center content-center" }
const _hoisted_67 = { class: "text-12px xxl:text-14px float-left pl-4 items-center" }
const _hoisted_68 = { class: "pr-4 float-right" }
const _hoisted_69 = {
  key: 0,
  class: "text-right text-16px text-red-lp-100"
}
const _hoisted_70 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_71 = { class: "inline" }
const _hoisted_72 = { class: "text-12px xxl:text-14px float-left pl-4" }
const _hoisted_73 = { class: "text-yellow-lp-100 " }
const _hoisted_74 = {
  key: 0,
  class: "pt-2",
  style: {"color":"#3D368F"}
}
const _hoisted_75 = { class: "text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_76 = { class: "pt-2 text-right text-yellow-lp-100" }
const _hoisted_77 = {
  key: 0,
  class: "pt-2 text-right",
  style: {"color":"#3D368F"}
}
const _hoisted_78 = /*#__PURE__*/_createVNode("svg", {
  class: "ml-3 z-9999 border-t border-white",
  style: {"margin-top":"-3px"},
  width: "17",
  height: "8",
  viewBox: "0 0 17 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M10.8128 6.23123L10.7981 6.24635L10.7848 6.26265C10.084 7.11752 9.26955 7.50001 8.50003 7.5C7.7305 7.49999 6.91604 7.11749 6.21529 6.26262L6.20193 6.24632L6.18724 6.2312L1.18284 1.07959L15.8172 1.0796L10.8128 6.23123Z",
    fill: "white",
    stroke: "#F5F5F5"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_ctx.isShow)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: "\n      absolute\n      overflow-y-auto\n      flex flex-col\n      rounded-t-lg\n    ",
        style: `margin-top: ${_ctx.isDiscountActive ? '100px' : '76px'};`
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("bookingShipment.estimation.title")), 1),
              (_ctx.showProductType)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("span", _hoisted_7, _toDisplayString(_ctx.dataDetail.productType), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("bulkBooking.estimation.publishRate")), 1),
                _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("bulkBooking.estimation.originForwardRate")), 1),
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("bulkBooking.estimation.destinationForwardRate")), 1),
                _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("bookingShipment.estimation.shipmentRates")), 1)
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.currency(_ctx.dataDetail.cityRates)), 1),
                _createVNode("div", _hoisted_17, _toDisplayString(_ctx.currency(_ctx.dataDetail.originDistrictRate)), 1),
                _createVNode("div", _hoisted_18, _toDisplayString(_ctx.currency(_ctx.dataDetail.destinationDistrictRate)), 1),
                _createVNode("div", _hoisted_19, _toDisplayString(_ctx.currency(_ctx.dataDetail.shippingCost)), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("bookingShipment.estimation.commoditySurcharge")), 1),
                _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("bookingShipment.estimation.weightAdditionalCharge")), 1),
                _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("bookingShipment.estimation.additionalDocumentCost")), 1),
                _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("bookingShipment.estimation.woodpackingCost")), 1),
                _createVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("bookingShipment.estimation.additionalCost")), 1)
              ]),
              _createVNode("div", _hoisted_28, [
                _createVNode("div", _hoisted_29, _toDisplayString(_ctx.currency(_ctx.dataDetail.commoditySurcharge)), 1),
                _createVNode("div", _hoisted_30, _toDisplayString(_ctx.currency(_ctx.dataDetail.heavyWeightSurcharge)), 1),
                _createVNode("div", _hoisted_31, _toDisplayString(_ctx.currency(_ctx.dataDetail.documentSurcharge)), 1),
                _createVNode("div", _hoisted_32, _toDisplayString(_ctx.currency(_ctx.dataDetail.woodpackingRates)), 1),
                _createVNode("div", _hoisted_33, _toDisplayString(_ctx.currency(_ctx.dataDetail.additionalCost)), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_34, [
            _createVNode("div", _hoisted_35, [
              _createVNode("div", _hoisted_36, [
                _createVNode("div", _hoisted_37, [
                  _createVNode("p", null, _toDisplayString(_ctx.$t("bookingShipment.estimation.protection")), 1),
                  (_ctx.dataDetail.insuranceName)
                    ? (_openBlock(), _createBlock("span", _hoisted_38, [
                        _createVNode("span", _hoisted_39, [
                          _createVNode("span", _hoisted_40, _toDisplayString(_ctx.dataDetail.insuranceName?.replace("Insurance", "")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, _toDisplayString(_ctx.currency(
                  _ctx.dataDetail.insuranceRates - _ctx.dataDetail.insuranceAdminFee
                )), 1)
              ])
            ]),
            (!_ctx.accountIsForeign)
              ? (_openBlock(), _createBlock("div", _hoisted_43, [
                  _createVNode("div", _hoisted_44, [
                    _createVNode("div", _hoisted_45, [
                      _createVNode("p", null, _toDisplayString(_ctx.$t("bookingShipment.estimation.protectionCost")), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_46, [
                    _createVNode("div", _hoisted_47, _toDisplayString(_ctx.currency(_ctx.dataDetail.insuranceAdminFee)), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          ((!_ctx.isForeignCurrency || _ctx.isInternational) && (_ctx.isCOD || _ctx.isDFOD))
            ? (_openBlock(), _createBlock("div", _hoisted_48, [
                _createVNode("div", _hoisted_49, [
                  _createVNode("div", _hoisted_50, [
                    _createVNode("div", _hoisted_51, _toDisplayString(_ctx.$t("bulkBooking.estimation.codGoodsValue")), 1),
                    _createVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("bulkBooking.estimation.codFee")), 1),
                    (_ctx.isEnableCodBooking)
                      ? (_openBlock(), _createBlock("div", _hoisted_53, " PAD Fee "))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_54, [
                    _createVNode("div", _hoisted_55, _toDisplayString(_ctx.isDFOD ? _ctx.currencyCodBlock(0) : _ctx.currencyCodBlock(_ctx.goodsValue)), 1),
                    _createVNode("div", _hoisted_56, _toDisplayString(_ctx.currencyCodBlock(_ctx.dataDetail.codFee)), 1),
                    (_ctx.isEnableCodBooking)
                      ? (_openBlock(), _createBlock("div", _hoisted_57, _toDisplayString(_ctx.currencyCodBlock(_ctx.dataDetail.padFee)), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isDiscountActive && _ctx.dataDetail.discountBoards)
            ? (_openBlock(), _createBlock("div", _hoisted_58, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataDetail.discountBoards, (promo, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "inline",
                    key: index
                  }, [
                    _createVNode("div", _hoisted_59, [
                      _createVNode("div", _hoisted_60, [
                        _createVNode("div", _hoisted_61, _toDisplayString(_ctx.startCase(promo.pdcCategory)) + " " + _toDisplayString(_ctx.$t("bulkBooking.estimation.promotion")), 1),
                        _createVNode("div", _hoisted_62, [
                          _createVNode("div", {
                            class: "\n                    flex flex-row\n                    bg-green-lp-700\n                    text-white text-10px\n                    px-1\n                    rounded-md\n                    cursor-pointer\n                  ",
                            onMouseenter: ($event: any) => (_ctx.onOpenTooltipPromo($event, index)),
                            onMouseleave: ($event: any) => (_ctx.onOpenTooltipPromo($event, index))
                          }, [
                            _createVNode("p", null, _toDisplayString(promo.pdcPromoDiscount) + "% " + _toDisplayString(_ctx.$t("bulkBooking.estimation.off")), 1),
                            _createVNode(_component_Icons, {
                              name: "info",
                              class: "w-3 ml-1"
                            })
                          ], 40, ["onMouseenter", "onMouseleave"]),
                          _createVNode(_component_OverlayPanel, {
                            ref: `infoPromo${index}`,
                            appendTo: "body",
                            class: "text-center",
                            style: {"width":"200px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode("p", _hoisted_63, _toDisplayString(promo.pdcName) + " " + _toDisplayString(_ctx.$t("bulkBooking.estimation.until")) + " " + _toDisplayString(_ctx.formatDateWithoutTime(promo.pdcEndDate)), 1)
                            ]),
                            _: 2
                          }, 1536)
                        ])
                      ]),
                      _createVNode("div", _hoisted_64, _toDisplayString(_ctx.currency(promo.pdcDiscountAmount)), 1)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_65, [
            _createVNode("div", _hoisted_66, [
              _createVNode("div", _hoisted_67, [
                _createVNode("div", {
                  class: 
                `${
                  _ctx.isDiscountActive && !_ctx.isCODOnly ? 'pt-5' : 'pt-2'
                } font-semibold text-black-lp-300 items-center`
              
                }, _toDisplayString(_ctx.isCOD || _ctx.isDFOD
                  ? _ctx.$t("bookingV3.shipment.checkTariff.detail.chargesPayable")
                  : _ctx.$t("bookingShipment.estimation.totalCost")), 3)
              ]),
              _createVNode("div", _hoisted_68, [
                _createVNode("div", {
                  class: 
                `pt-2 text-right text-16px ${
                  _ctx.isDiscountActive && !_ctx.isCODOnly && _ctx.discountData.length
                    ? 'text-gray-lp-600 line-through'
                    : 'text-red-lp-100 font-semibold'
                }`
              ,
                  "data-testid": "bulk-booking-repair-estimation-total-tariff"
                }, _toDisplayString(_ctx.isCODOnly || (!_ctx.isDiscountActive && _ctx.isDFOD)
                  ? _ctx.currency(_ctx.dataDetail.codAmount)
                  : _ctx.currency(_ctx.dataDetail.totalTariff)), 3),
                (_ctx.isDiscountActive && !_ctx.isCODOnly && _ctx.discountData.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_69, _toDisplayString(_ctx.isDFOD
                  ? _ctx.currency(_ctx.dataDetail.codAmount)
                  : _ctx.currency(_ctx.dataDetail.totalTariffAfterDiscount)), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_70, [
            _createVNode("div", _hoisted_71, [
              _createVNode("div", _hoisted_72, [
                _createVNode("div", _hoisted_73, _toDisplayString(_ctx.$t("bookingV3.shipment.checkTariff.detail.estimationTax")), 1),
                (_ctx.isCodRetail)
                  ? (_openBlock(), _createBlock("div", _hoisted_74, _toDisplayString(_ctx.$t("bookingV3.shipment.checkTariff.detail.returnCost")), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_75, [
                _createVNode("div", _hoisted_76, _toDisplayString(_ctx.currency(_ctx.dataDetail.taxRates)), 1),
                (_ctx.isCodRetail)
                  ? (_openBlock(), _createBlock("div", _hoisted_77, _toDisplayString(_ctx.currency(_ctx.codReturnFee)), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _hoisted_78
      ], 4))
    : _createCommentVNode("", true)
}